import React, { useEffect, useRef, useState } from 'react'
import { superAxiosRequest } from 'axiosApi'
import { localisationMaster } from 'Localisation/Localisation'
import Select from '../Select/Select'
import SelectCustom from '../Select/SelectCustom'
import TypeSelector from '../GlobalModalSingle/templates/WorkPlain/TypeSelector'
import DatePicker from 'react-datepicker'
import listingStore from 'Stores/listingStore'
import LocalStorage from 'services/LocalStorage'
import './Filter.scss'
import { translate as loc, dict } from 'Localisation'
import MultiSelect from '../Idlist/MultiSelect'
import Checkbox from '../Checkbox/Checkbox'
import DateTime from '../DateTime/DateTime'

export default function Filter(props) {
  const dataArr = [
    { id: 1, name: 'Прошли тест сегодня' },
    { id: 2, name: 'Прошли тест вчера' },
    { id: 3, name: 'Прошли тест позавчера' },
    { id: 4, name: 'Прошли тест раньше' },
  ]

  const [inputsValues, setInputsValues] = useState({})
  const [thisPage, setThisPage] = useState(null)
  const [open, setOpen] = useState(props.openFilter === true)

  const dropFilter = () => {
    setInputsValues([])
    props.drop()
  }

  const getFilterArr = () => {
    const selectArr = []
    const data = LocalStorage.get('ud')
    const lang = (data?.user_data.profile.localization || 'en').toLowerCase()

    props.config.forEach((item, index) => {
      switch (item.type) {
        case 'select':
          selectArr.push(
            <div className='filter-box__field' key={index}>
              <SelectCustom
                placeholder={item.text}
                apiLink={item.apiLink}
                apiGetResult={
                  item.key_name ? (data) => data[item.key_name].items : null
                }
                valueID={returnValue(item.nameState)}
                onChange={(o) =>
                  changeHandler({ target: o }, item.nameState, item.subMenu)
                }
                isSearchable
              />
            </div>,
          )
          break
        case 'input':
          selectArr.push(
            <div className='filter-box__field' key={index}>
              <input
                type='text'
                placeholder={item.placeholder}
                value={returnValue(item.nameState)}
                onChange={(e) => changeHandler(e, item.nameState, item.subMenu)}
                className='filter-box__input'
              />
            </div>,
          )
          break
        case 'select-custom':
          selectArr.push(
            <div key={index} className='filter-box__field'>
              <SelectCustom
                placeholder={item.placeholder}
                options={item.values}
                optionLabelKey={item.option_label_key}
                optionValueKey={item.option_value_key}
                onChange={(o) =>
                  item.is_multi
                    ? changeHandler(
                        { target: { value: o.map((item) => item.value) } },
                        item.nameState,
                        item.subMenu,
                      )
                    : changeHandler(
                        { target: { value: o.value } },
                        item.nameState,
                        item.subMenu,
                      )
                }
                apiLink={item.apiLink}
                apiGetResult={item.apiGetResult}
                sortKey={item.sort_key}
                valueID={
                  item.is_multi
                    ? inputsValues[item.nameState] || []
                    : returnValue(item.nameState, 1)
                }
                isSearchable={item.is_search}
                isMulti={item.is_multi}
              />
            </div>,
          )
          break
        case 'select-bound':
          selectArr.push(
            <div key={index} className='filter-box__field'>
              <SelectCustom
                placeholder={item.placeholder}
                options={
                  inputsValues[item.bindingToState]
                    ? item.values.find(
                        (itemArray) =>
                          itemArray.id === inputsValues[item.bindingToState],
                      )[item.bindingKey]
                    : [{ id: 1, name: item.noOptionsMessage }]
                }
                optionLabelKey={item.option_label_key}
                optionValueKey={item.option_value_key}
                onChange={(o) =>
                  changeHandler(
                    { target: { value: o.value } },
                    item.nameState,
                    item.subMenu,
                  )
                }
                apiLink={item.apiLink}
                apiGetResult={item.apiGetResult}
                sortKey={item.sort_key}
                valueID={
                  inputsValues[item.bindingToState]
                    ? returnValue(item.nameState, 1)
                    : 1
                }
                isSearchable={item.is_search}
                isDisabled={!inputsValues[item.bindingToState]}
              />
            </div>,
          )
          break
        case 'type-selector':
          selectArr.push(
            <div className='filter-box__field' key={index}>
              <TypeSelector
                values={item.values}
                like_obj={true}
                objectChangeHandler={objectChangeHandler}
                selected={returnValue(item.nameState)}
                name={item.nameState}
                //width={'240px'}
              />
            </div>,
          )
          break
        case 'month-range-picker':
          selectArr.push(
            <div className='filter-box__field' key={index}>
              <div className='filter-box__month-range-picker react-datepicker-custom'>
                <div>
                  <DatePicker
                    selected={inputsValues[item.nameState[0]]}
                    onChange={(date) =>
                      objectChangeHandler(date, item.nameState[0])
                    }
                    dateFormat='MM, yyyy'
                    showMonthYearPicker
                    showFullMonthYearPicker
                    locale={lang}
                    maxDate={inputsValues[item.nameState[1]]}
                  />
                </div>
                <div>{loc(dict.main_page.text_51)}</div>
                <div>
                  <DatePicker
                    selected={inputsValues[item.nameState[1]]}
                    onChange={(date) =>
                      objectChangeHandler(date, item.nameState[1])
                    }
                    dateFormat='MM, yyyy'
                    showMonthYearPicker
                    showFullMonthYearPicker
                    locale={lang}
                    minDate={inputsValues[item.nameState[0]]}
                  />
                </div>
              </div>
            </div>,
          )
          break
        case 'days-range-picker':
          selectArr.push(
            <div className='filter-box__field' key={index}>
              <div className='filter-box__month-range-picker react-datepicker-custom'>
                <div>
                  <DatePicker
                    selected={
                      inputsValues[item.nameState[0]] ||
                      item?.defaultDate?.after
                    }
                    onChange={(date) =>
                      objectChangeHandler(date, item.nameState[0])
                    }
                    dateFormat='dd.MM.yyyy'
                    locale={lang}
                    maxDate={inputsValues[item.nameState[1]]}
                  />
                </div>
                <div>{loc(dict.main_page.text_51)}</div>
                <div>
                  <DatePicker
                    selected={
                      inputsValues[item.nameState[1]] ||
                      item?.defaultDate?.before
                    }
                    onChange={(date) =>
                      objectChangeHandler(date, item.nameState[1])
                    }
                    dateFormat='dd.MM.yyyy'
                    locale={lang}
                    minDate={inputsValues[item.nameState[0]]}
                  />
                </div>
              </div>
            </div>,
          )
          break
        case 'times-range-picker':
          selectArr.push(
            <div className='filter-box__field' key={index}>
              <div className='filter-box__month-range-picker react-datepicker-custom'>
                <DateTime
                  placeholder='9:00'
                  errorCheker={() => {}}
                  start_at={inputsValues[item.nameState[0]]}
                  finish_at={inputsValues[item.nameState[1]]}
                  objectChangeHandler={objectChangeHandler}
                />
              </div>
            </div>,
          )
          break
        case 'checkbox':
          selectArr.push(
            <div
              key={index}
              className='filter-box__field filter-box__field--checkbox'
            >
              <Checkbox
                label={item.label}
                checked={inputsValues[item.name]}
                name={item.name}
                onChange={() =>
                  objectChangeHandler(!inputsValues[item.name], item.name)
                }
              />
            </div>,
          )
          break
        default:
          break
      }
    })

    return selectArr
  }

  const changeHandler = (e, key_name, subMenu_key) => {
    setInputsValues({
      ...inputsValues,
      [key_name]: e.target.value,
      ...(subMenu_key !== undefined && { [subMenu_key]: props.subMenu }),
      //is_active: true,
    })
  }

  const objectChangeHandler = (value, key_name, subMenu_key) => {
    if (subMenu_key !== undefined) {
      setInputsValues({
        ...inputsValues,
        [key_name]: value,
        [subMenu_key]: props.subMenu,
        is_active: true,
      })
    } else {
      setInputsValues({ ...inputsValues, [key_name]: value })
    }
  }

  const returnValue = (key_name, int) => {
    if (
      inputsValues !== null &&
      inputsValues !== undefined &&
      inputsValues.length !== 0 &&
      inputsValues[key_name] !== undefined
    ) {
      return inputsValues[key_name]
    } else {
      if (!int) {
        return ''
      } else {
        return 0
      }
    }
  }

  const getFilterValue = (link) => {
    if (props.getFilterParams) {
      props.getFilterParams(inputsValues)
      return
    }

    let paramsValue = inputsValues
    let params = props.params
    if (params) paramsValue = Object.assign(params, inputsValues)
    for (let key in paramsValue) {
      if (typeof paramsValue[key] === 'string')
        paramsValue[key] = paramsValue[key].trim()
    }
    if (props.setPage) props.setPage(1)
    listingStore.toFilter = paramsValue
    let apiConf = {
      method: 'get',
      params: paramsValue,
      link: link,
    }
    listingStore.setFilterConf(inputsValues)
    listingStore.fillData(apiConf)
  }

  const openFilter = () => {
    setOpen(!open)
  }

  useEffect(() => {
    if (props.thisPage !== thisPage) {
      setInputsValues([])
      dropFilter()
      setThisPage(props.thisPage)
    }
  })

  useEffect(() => {
    refSlider.current.style.height = open
      ? refSlide.current.offsetHeight + 'px'
      : ''
  }, [open, inputsValues])

  useEffect(() => {
    props.config.forEach((item) => {
      if (item.data) {
        setInputsValues({ ...inputsValues, ...item.data })
      }
    })
    return () => {
      listingStore.toFilter = false
      listingStore.setFilterConf([])
    }
  }, [])

  const refSlider = useRef()
  const refSlide = useRef()

  return (
    <div className='filter-box'>
      <div className='filter-box__header' onClick={() => openFilter()}>
        <span className='filter-box__header-title'>
          {localisationMaster('text-4', 'filter')}
        </span>
        <span className='filter-box__toggle-button'>
          {!open
            ? localisationMaster('text-5', 'filter')
            : localisationMaster('text-6', 'filter')}
        </span>
      </div>
      <div className='filter-box__slider' ref={refSlider}>
        <div ref={refSlide} className='filter-box__slide'>
          <div className='filter-box__fields'>{getFilterArr()}</div>
          <div className='filter-box__buttons'>
            <div>
              <button
                className='filter-box__apply-button'
                onClick={() => getFilterValue(props.link)}
              >
                {localisationMaster('text-7', 'filter')}
              </button>
            </div>
            <span className='filter-box__reset-button' onClick={dropFilter}>
              {localisationMaster('text-10', 'filter')}
            </span>
          </div>
        </div>
      </div>
    </div>
  )
}
